import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div({
  flex: '1 0 auto',
});

export const PageContainer = styled.div<Theme>(({ theme }) => ({
  margin: '0 auto',
  paddingBottom: theme.spacing(6),
  paddingTop: theme.spacing(6),
  width: '90%',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}));
